module.exports = __webpack_public_path__ + "static/media/Gorrissen_Federspiel_2026_PDF.2185353c.pdf";